export default __webpack_public_path__ + "static/media/hexofy-logo-rectangle-white.294d4dab.svg";